<template>
  <div class="app-top">
    <div class="container">
      <div class="row">
        <h3 class="title col-sm-12">订单查询</h3>
        <div class="col-sm-6">
          <div class="input-group mb-3">
            <input type="text" class="form-control" placeholder="输入订单号，手机号" v-model="keyword" @keyup.13="searchInput" />
            <div class="input-group-append">
              <span class="input-group-text" style=" cursor: pointer;" @click="searchInput" v-loading="loading">查询</span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 box">
          <div v-if="orderList.length>0">
            <div class="box-title">查询到{{orderList.length}}条数据</div>
            <div
              class="row box-list col-sm-12 box"
              style="border:1px solid #ddd;border-radius: 10px; margin:10px 0 0 0;padding:10px"
              v-for="(item,index) in orderList"
              :key="index"
            >
              <a :href="`/#/order/confirm/?orderNo=${item.no}`" target="_blank">{{item.no}}</a>
              <div class="row col-12">{{item.softName}} {{item.licenseTypeText}} {{item.paymentAmount.toFixed(2)}}</div>
              <div class="row col-12">{{item.createTime}}</div>
            </div>
          </div>
          <div v-if="orderList.length == 0 && isSearch">{{`未找到“${keyword}”相关订单`}}</div>
        </div>
        <div class="bottom col-sm-12">
          <h5 style="padding: 10px;">注意事项</h5>
          <p>1.如果输入订单号或购买软件时填写的电子邮箱后没有查询到激活码，请点击这里查询。</p>
          <p>2.如果您通过自助查询系统没有查询到激活码，请和我们的客户服务人员联系。</p>
          <p>3.如果您是在我们的淘宝代理商购买的激活码，请和淘宝商家联系。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api/order'
export default {
  name: '',
  data() {
    return {
      keyword: '',
      orderList: [],
      loading: false,
      isSearch: false
    }
  },
  watch: {},
  computed: {},
  methods: {
    searchInput() {
      if (!this.keyword) {
        this.$Message({
          showClose: true,
          message: '请输入订单号或者手机',
          type: 'error'
        })
        return false
      }
      this.getList()
    },
    getList() {
      this.loading = true
      API.getList({ keyword: this.keyword }).then(res => {
        this.orderList = res.data.list
        this.loading = false
        this.isSearch = true
      })
    },
    handlerOrder(no) {
      this.$router.push({ name: 'Detail', params: { orderNum: no } })
    }
  },
  created() {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
.app-top {
  margin-top: 78px;
  min-height: calc(100vh - 370px);
}
.container {
  padding: 20px;
  // .row {
  //   width: 60%;
  //   margin: 0 auto;
  //   background: chartreuse;
  // }
  .title {
    padding-bottom: 20px;
  }
  .box {
    min-height: 50px;
    .box-list {
      // color: #1997f9;
      font-size: 14px;
    }
  }
  .bottom {
    margin-bottom: 20px;
  }
}
</style>